import React, { useMemo, useState, useRef } from "react";
import { IoMdArrowForward } from "react-icons/io";
// import { TEMPLATE_OPTIONS } from "../../../Settings/Templates/templateConts";
import Modal1 from "../../../../components/DIsplay/Modal/Modal1";
import Button1 from "../../../../components/form/Button1";
import { useSelector } from "react-redux";
import RadioGroup from "../../../../components/form/RadioGroup";
import EmailExport from "../../../Orders/Flight/Booked/EmailExport";
import usePDF from "../../../../hooks/flight/usePDF";
import { useParams } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { shareFlightBookingPDF } from "../../../../controllers/Flight/shareFlightBookingPDF";

function ChangeDateConfirmationSecondaryHeader({ data }) {
  const componentRef = useRef();
  const componentPriceRef = useRef();
  const { id } = useParams();
  const [exportModal, setExportModal] = useState(false);
  const [openPDFExport, setOpenPDFExport] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("pdf");
  const { crmData } = useSelector((state) => state.user.userData);
  const [openEmailExport, setOpenEmailExport] = useState(false);
  const { handlePDFExport, handlePDFDownload } = usePDF();

  // console.log({ data });

  const routeType = useMemo(() => {
    const destinations = data?.selectedOffer?.destinations || [];
    if (destinations?.length === 1) return "One way";
    if (destinations?.length === 2) {
      if (
        destinations[0]?.from === destinations[1]?.to &&
        destinations[0]?.to === destinations[1]?.from
      ) {
        return "Round trip";
      }
    }
    return "Multi city";
  }, [data]);

  const cities = useMemo(() => {
    const directions = data?.selectedOffer?.directions || [];
    switch (routeType) {
      case "Round trip": {
        const direction = directions[0];
        const firstSeg = direction[0];
        const lastSeg = direction[direction?.length - 1];
        return [firstSeg?.departure?.city, lastSeg?.arrival?.city];
      }
      default:
        return directions?.flatMap((direction, directionIndex) => {
          const firstSeg = direction[0];
          const items = [firstSeg?.departure?.city];
          if (directionIndex === directions?.length - 1) {
            const lastSeg = direction[direction?.length - 1];
            items.push(lastSeg?.arrival?.city);
          }
          return items;
        });
    }
  }, [data, routeType]);

  const displayableItems = useMemo(() => {
    const items = [];
    for (let i = 0; i < cities?.length; i++) {
      const city = cities[i];
      items.push({ type: "city", city });
      if (i < cities?.length - 1) items.push({ type: "arrow" });
    }
    return items;
  }, [cities]);

  // const PDF = ({ price = false }) => {
  //   const content = {
  //     ...{
  //       booking: { flightBooking: [data?.changedFlightBooking] },
  //       change: data,
  //     },
  //     price,
  //   };
  //   const ticketTemplate = TEMPLATE_OPTIONS.tickets.find(
  //     (template) => template?.code === crmData?.shareBookingPdf?.ticket
  //   );
  //   return (
  //     ticketTemplate?.template(content) ||
  //     TEMPLATE_OPTIONS.tickets[0].template(content)
  //   );
  // };

  async function handleOption() {
    if (selectedOption === "email") setOpenEmailExport(true);
    else if (selectedOption === "pdf") {
      // setOpenPDFExport(true);
      // // await new Promise((resolve) => setTimeout(() => resolve(), 2000));

      const componentToRender = componentRef.current;
      if (componentToRender) {
        setDownloading(true);
        await handlePDFDownload(componentToRender?.outerHTML, {
          fileName: data?.changedFlightBooking?.bookingId || "Change order",
        }).finally(() => setDownloading(false));
        // setTimeout(
        //   () =>
        //     // handlePrint()
        //     handlePDFExport(),
        //   1000
        // );
      }
    } else if (selectedOption === "pdf-price") {
      // setOpenPDFExport(true);
      // // await new Promise((resolve) => setTimeout(() => resolve(), 2000));

      const componentToRender = componentPriceRef.current;
      if (componentToRender) {
        setDownloading(true);
        await handlePDFDownload(componentToRender?.outerHTML, {
          fileName: data?.changedFlightBooking?.bookingId || "Change order",
        }).finally(() => setDownloading(false));
        // setTimeout(
        //   () =>
        //     // handlePrint()
        //     handlePDFExport(),
        //   1000
        // );
      }
    } else if (selectedOption === "pdfMod") {
      window.open("/order/flight/export/" + id + "?page=", "_blank");
    }

    setExportModal(false);
  }

  async function sendPDF(pdf, datas) {
    const bookingId = data?.changedFlightBooking?.bookingId;
    const date = data?.changedFlightBooking?.createdDate;
    const departure =
      data?.changedFlightBooking?.directions?.at(0)?.at(0)?.departure?.city ||
      data?.changedFlightBooking?.flights[0]?.departureLocation;
    const arrival =
      data?.changedFlightBooking?.directions?.at(0)?.at(0)?.arrival?.city ||
      data?.changedFlightBooking?.arrivalLocation;

    const formData = new FormData();

    datas?.map((data) => formData?.append("to", data.email));
    formData.append("subject", "Flight Booking Details");
    formData.append(
      "body",
      "Booking details of " + departure + " to " + arrival
    );
    formData.append("pdf", pdf, bookingId + "--" + date + ".pdf");

    enqueueSnackbar("Sending... (This might take a while if the pdf is large)");
    const res = await shareFlightBookingPDF(formData);
    if (res.return) {
      enqueueSnackbar(res?.msg, { variant: "success" });
    } else enqueueSnackbar(res?.msg, { variant: "error" });
  }

  async function handleEmailExport(data) {
    setOpenPDFExport(true);
    await new Promise((resolve) => setTimeout(() => resolve(), 2000));
    const componentToRender = componentRef.current;
    console.log(componentToRender);
    await handlePDFDownload(componentToRender.outerHTML, {
      fileName: data?.changedFlightBooking?.bookingId,
      callback: ({ blob }) => {
        sendPDF(blob, data, {
          fileName: data?.changedFlightBooking?.bookingId,
        });
      },
    });

    // setTimeout(() =>
    //   handlePDFExport((pdf) => sendPDF(pdf, data),{fileName: order?.booking?.bookingId})
    // , 500);
    setOpenEmailExport(false);
  }

  return (
    <div className="w-full bg-white rounded-md p-4 gap-4 flex items-center justify-between flex-col lg:flex-row relative">
      <Modal1 open={openEmailExport} setOpen={setOpenEmailExport}>
        <EmailExport callback={handleEmailExport} />
      </Modal1>
      <Modal1 open={exportModal} setOpen={setExportModal}>
        <div className="card p-10 flex flex-col gap-4">
          <h5 className="self-center">Export Order</h5>
          <RadioGroup
            options={[
              {
                title: "Export PDF to Email",
                description: "Select the option to export the order via email",
                value: "email",
              },
              {
                title: "Download PDF Without Price",
                description: "Select the option to export the order via PDF",
                value: "pdf",
              },
              {
                title: "Download PDF With Price",
                description: "Select the option to export the order via PDF",
                value: "pdf-price",
              },
              {
                title: "Modify PDF",
                description:
                  "Select the option to modify and export the order via PDF",
                value: "pdfMod",
              },
            ]}
            className="flex flex-col gap-4"
            radioClass="!items-start"
            render={(obj) => (
              <div className="flex flex-col ">
                <b>{obj.title}</b>
                <p>{obj.description}</p>
              </div>
            )}
            value={selectedOption}
            onChange={(val) => setSelectedOption(val)}
          />

          <Button1 onClick={handleOption}>
            {downloading ? <div className="buttonLoader"></div> : <> Confirm</>}
          </Button1>
        </div>
      </Modal1>
      <div className="hidden">
        <div className="" ref={componentRef}>
          {/* <PDF /> */}
          {/* <TicketGTemplate order={order} /> */}
          {/* <QuoteEmailATemplate order={order} /> */}
        </div>
        <div className="" ref={componentPriceRef}>
          {/* <PDF price /> */}
          {/* <TicketGTemplate order={order} /> */}
          {/* <QuoteEmailATemplate order={order} /> */}
        </div>
      </div>
      <div className="flex gap-4 w-full lg:w-fit items-center justify-between">
        <div className="text-primary1 text-sm font-semibold bg-primary1/10 rounded-md w-28 flex items-center justify-center py-1">
          {routeType}
        </div>
        <div className="flex gap-2 flex-wrap justify-end items-center">
          {displayableItems?.map((item, itemIndex) =>
            item?.type === "city" ? (
              <div key={itemIndex}>
                <span className="font-bold text-lg">{item?.city}</span>
              </div>
            ) : (
              <div key={itemIndex} className="text-lg">
                <IoMdArrowForward />
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
}

export default ChangeDateConfirmationSecondaryHeader;
